import { render, staticRenderFns } from "./ProfileInfoPopup.vue?vue&type=template&id=00b6c77c&scoped=true"
import script from "./ProfileInfoPopup.vue?vue&type=script&lang=js"
export * from "./ProfileInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfoPopup.vue?vue&type=style&index=0&id=00b6c77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6c77c",
  null
  
)

export default component.exports